import React from 'react'

import { getItems } from 'src/graphql'
import { useQueries } from 'src/hooks'

import { CampaignList } from '../components'

interface Props {
  categoryId?: string
  searchTerm: string
  onPreview: (id: string) => void
  onPurchase: (id: string) => void
  isScrollBarEnabled: boolean
}

const SearchResults: React.FC<Props> = props => {
  const {
    categoryId,
    searchTerm,
    onPreview,
    onPurchase,
    isScrollBarEnabled,
  } = props

  const [items] = useQueries(
    getItems({
      category: categoryId,
      search: searchTerm,
    }),
  )

  return (
    <CampaignList
      category={{
        id: '0',
        name: 'Search Results',
        items,
      }}
      isScrollBarEnabled={isScrollBarEnabled}
      isSeeAllButtonEnabled={false}
      isWrapContentEnabled={true}
      onPurchase={onPurchase}
      onPreview={onPreview}
    />
  )
}

export default SearchResults
